import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import { TextButton } from "@qgiv/core-donor";
import ParticipantCounterAddAnotherButton from "./ParticipantCounterAddAnotherButton";

const ParticipantCounter = ({
    addAdditionalAriaLabel,
    addParticipantLinkLabel,
    addRegistration = () => {},
    allowSubRegistrantToChangeRegRole,
    baseUrl,
    displayParticipantCounterNumber,
    displayAddAnotherButton,
    isCms,
    participants,
    primaryRegistration,
    regSubsectionHeading,
    setAppShowRegistrationRole = () => {},
    setAppShowRemainingForm = () => {},
}) => (
    // eslint-disable-next-line tailwindcss/classnames-order
    <div className="grid grid--no-gutters">
        <div className="col">
            <small>
                <Icon
                    className="-margin-right--10"
                    glyph="user-solid"
                    type="FontAwesome"
                />
                <strong>
                    <span className="-text-transform--uppercase">
                        {regSubsectionHeading}
                    </span>
                    {displayParticipantCounterNumber && (
                        <span> {`x ${participants}`}</span>
                    )}
                </strong>
            </small>
        </div>
        <div className="col -text--right">
            {displayAddAnotherButton && (
                <small>
                    {isCms ? (
                        <TextButton ariaLabel={addAdditionalAriaLabel}>
                            <strong>{addParticipantLinkLabel}</strong>
                        </TextButton>
                    ) : (
                        <ParticipantCounterAddAnotherButton
                            addAdditionalAriaLabel={addAdditionalAriaLabel}
                            addParticipantLinkLabel={addParticipantLinkLabel}
                            addRegistration={addRegistration}
                            allowSubRegistrantToChangeRegRole={
                                allowSubRegistrantToChangeRegRole
                            }
                            baseUrl={baseUrl}
                            primaryRegistration={primaryRegistration}
                            setAppShowRegistrationRole={
                                setAppShowRegistrationRole
                            }
                            setAppShowRemainingForm={setAppShowRemainingForm}
                        />
                    )}
                </small>
            )}
        </div>
    </div>
);

ParticipantCounter.propTypes = {
    // More descriptive aria label for add participant label
    addAdditionalAriaLabel: PropTypes.string.isRequired,
    // Text to display in "add participant" button
    addParticipantLinkLabel: PropTypes.string.isRequired,
    // Redux action to add a new registration to registrations
    addRegistration: PropTypes.func,
    allowSubRegistrantToChangeRegRole: PropTypes.bool.isRequired,
    // Start of navigate url which includes event alias
    baseUrl: PropTypes.string.isRequired,
    // Flag that indicates when participant counter number should be displayed
    displayParticipantCounterNumber: PropTypes.bool.isRequired,
    // Flag that indicates whether add another button should be displayed
    displayAddAnotherButton: PropTypes.bool.isRequired,
    // Flag that indicates whether we are loading this component in CMS
    isCms: PropTypes.bool.isRequired,
    // Running count of participants
    participants: PropTypes.number.isRequired,
    primaryRegistration: PropTypes.shape({}).isRequired,
    // Texts to use in place of "registration"
    regSubsectionHeading: PropTypes.string.isRequired,
    // Redux action to hide registration role section
    setAppShowRegistrationRole: PropTypes.func,
    // Redux action to hide rest of registration form
    setAppShowRemainingForm: PropTypes.func,
};

export default ParticipantCounter;
